import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createJobAction } from "../redux/actions/jobAction";
import { useNavigate } from "react-router-dom";

import { countries } from "../data/countries";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Image from "../images/hero_1.jpg";
// import PriceRange from "../component/RangeSlider";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

const validationSchema = yup.object({
  position: yup
    .string()
    .min(3, "enter at least more than 3 characters")
    .required("position is required"),
  jobType: yup
    .string("select JobType")
    .min(3)
    .required("job type is required."),
  jobCategory: yup.string().min(3).required("job category is required."),
  jobLocation: yup.string().min(3).required("job Location is required."),
  minSalary: yup.number().required("minSalary is required."),
  maxSalary: yup.number().required("maxSalary is required."),
});

const CreateJob = () => {
  const [image, setImage] = useState("");
  const [aboutTheRole, setRole] = useState("");
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.signIn);
  const { loading } = useSelector((state) => state.loadJobs);
  console.log(loading);
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      position: "",
      jobType: "",
      jobLocation: "",
      jobDescription: "",
      aboutTheRole: "",
      jobCategory: "",
      minSalary: null,
      maxSalary: null,
    },
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      if (userInfo.user.pending === true) {
        toast.error("Your company is under moderation", {
          position: "bottom-right",
        });
        return;
      }
      values.jobLogo = image;
      console.log(values);
      dispatch(createJobAction(values, navigate));
      //actions.resetForm();
    },
  });

  const [content, setContent] = useState("");
  const handleQuillChange = (value) => {
    setContent(value);
    const strippedValue = value.replace(/^<p>(.*?)<\/p>$/, "$1");
    formik.setFieldValue("jobDescription", strippedValue);
    // Use the plainText variable to submit the form data
  };
  const handleAboutTheRoleChange = (value) => {
    setRole(value);
    let strippedValue = value.replace(/<\/?li>/g, "-");
    strippedValue = strippedValue.replace(/<\/?ul>|<\/?ol>/g, "");
    strippedValue = strippedValue.replace(/- -/g, "-");
    formik.setFieldValue("aboutTheRole", strippedValue);
    // Use the plainText variable to submit the form data
  };

  const handleImageChange = (file) => {
    const reader = new FileReader();

    // Check if the selected file is an image
    if (!file.type.startsWith("image/")) {
      toast.error("Selected file is not an image!", {
        position: "bottom-right",
      });
      return;
    }
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64Img = reader.result;
      setImage(base64Img);
    };
  };

  return (
    <>
      <section
        class="section-hero overlay inner-page bg-image"
        id="home-section"
        style={{
          backgroundImage: `url(${Image})`,
        }}
      >
        <div class="container">
          <div class="row">
            <div class="col-md-7">
              <h1 class="text-white font-weight-bold">Post A Job</h1>
              <div class="custom-breadcrumbs">
                <Link style={{ color:'white'}} to="/">
                  Home
                </Link>{" "}
                <span class="mx-2 slash">/</span>
                <span class="text-white">
                  <strong>Post a Job</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="site-section">
        <div class="container">
          <div class="row align-items-center mb-5">
            <div class="col-lg-8 mb-4 mb-lg-0">
              <div class="d-flex align-items-center">
                <div>
                  <h2>Post A Job</h2>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-lg-12">
              <form
                class="p-4 p-md-5 border rounded"
                onSubmit={formik.handleSubmit}
              >
                <h3 class="text-black mb-5 border-bottom pb-2">Job Details</h3>

                <div class="form-group">
                  <label for="company-website-tw d-block">
                    <b>Upload Featured Image</b>
                  </label>{" "}
                  <br />
                  <label
                    class="btn btn-primary btn-md btn-file"
                    style={{
                      backgroundColor: "#1d4ed8",
                      borderColor: "#1d4ed8",
                    }}
                  >
                    Browse File
                    <input
                      type="file"
                      onChange={(e) => handleImageChange(e.target.files[0])}
                    />
                  </label>
                  <br />
                  {image && (
                    <img src={image} alt="image" style={{ width: "100px" }} />
                  )}
                </div>
                <div className="form-group">
                  <label for="job-title">
                    <b>Job Position</b>
                  </label>
                  <input
                    type="text"
                    className="form-control mb-3"
                    id="job-title"
                    name="position"
                    placeholder="Product Designer"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.position}
                    style={{
                      borderColor:
                        formik.errors.position && formik.touched.position
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.position && formik.touched.position
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.position && formik.touched.position && (
                    <p style={{ color: "red" }}>{formik.errors.position}</p>
                  )}
                </div>
                <div className="form-group">
                  <label for="job-location">
                    <b>Location</b>
                  </label>
                  <input
                    type="text"
                    className="form-control mb-3"
                    id="job-location"
                    name="jobLocation"
                    placeholder="e.g. New York"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.jobLocation}
                  />
                  {formik.errors.jobLocation && formik.touched.jobLocation && (
                    <p style={{ color: "red" }}>{formik.errors.jobLocation}</p>
                  )}
                </div>
                <div>
                  <div class="JobTypeC">
                    <div className="selectType">
                      <label for="job-type">
                        <b>Job Type</b>
                      </label>

                      <select
                        className="form-control form-control-lg"
                        data-style="btn-white btn-lg"
                        data-live-search="true"
                        title="Select Category"
                        name="jobType"
                        style={{ backgroundColor: "white" }}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.jobType}
                      >
                        <option value="part-time">Part Time</option>
                        <option value="full-time">Full Time</option>
                        <option value="remote">Remote</option>
                        <option value="internship">Internship</option>
                      </select>
                      {formik.errors.jobType && formik.touched.jobType && (
                        <p style={{ color: "red" }}>{formik.errors.jobType}</p>
                      )}
                    </div>
                    <div className="selectType">
                      <label>
                        <b>Job Category</b>
                      </label>
                      <select
                        className="form-control form-control-lg"
                        data-style="btn-white btn-lg"
                        data-live-search="true"
                        title="Select Category"
                        name="jobCategory"
                        style={{ backgroundColor: "white" }}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.jobCategory}
                      >
                        {countries.map((country) => (
                          <option key={country} value={country}>
                            {country}
                          </option>
                        ))}
                      </select>
                      {formik.errors.jobCategory &&
                        formik.touched.jobCategory && (
                          <p style={{ color: "red" }}>
                            {formik.errors.jobCategory}
                          </p>
                        )}
                    </div>
                  </div>

                  <div className="salaryC">
                    <div className="selectType">
                      <label for="minSalary">
                        <b>minSalary($)</b>
                      </label>
                      <input
                        type="number"
                        class="form-control mb-3"
                        id="minSalary"
                        name="minSalary"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.minSalary}
                      />
                      {formik.errors.minSalary && formik.touched.minSalary && (
                        <p style={{ color: "red" }}>
                          {formik.errors.minSalary}
                        </p>
                      )}
                    </div>
                    <div className="selectType">
                      <label for="maxSalary">
                        <b>maxSalary($)</b>
                      </label>
                      <input
                        type="number"
                        class="form-control mb-3"
                        id="maxSalary"
                        name="maxSalary"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.maxSalary}
                      />
                      {formik.errors.maxSalary && formik.touched.maxSalary && (
                        <p style={{ color: "red" }}>
                          {formik.errors.maxSalary}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="job-description">
                    <b>Job Description</b>
                  </label>
                  <div class="editor" id="editor-1">
                    <ReactQuill
                      theme="snow"
                      style={{ height: "300px" }}
                      value={content}
                      onChange={handleQuillChange}
                      name="jobDescription"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label for="job-description">
                    <b>About the role</b>
                  </label>
                  <div class="editor" id="editor-1">
                    <ReactQuill
                      theme="snow"
                      style={{ height: "300px" }}
                      value={aboutTheRole}
                      onChange={handleAboutTheRoleChange}
                      name="aboutTheRole"
                      formats={["list"]}
                    />
                  </div>
                </div>
                <div class="row align-items-center mb-5">
                  <div class="col-lg-4 ml-auto">
                    <div class="row">
                      <div class="col-6"></div>
                      <div class="col-6">
                        <button
                        onClick={()=>navigate('/')}
                          type="submit"
                          class="btn btn-block btn-primary btn-md"
                          disabled={loading}
                          style={{
                            backgroundColor: "#8D2CDC",
                            borderColor: "#8D2CDC",
                            width: "100%",
                          }}
                        >
                          {loading ? <CircularProgress /> : "Post Job"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CreateJob;
